"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validatorJS = require("validator");
class IsAlphaValidator {
    constructor(locale) {
        this.locale = locale;
    }
    isValid(input) {
        if (input) {
            return validatorJS.isAlpha(input, this.locale);
        }
        return false;
    }
}
exports.IsAlphaValidator = IsAlphaValidator;
//# sourceMappingURL=IsAlphaValidator.js.map